/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect } from "react";
import { Image, Modal, Row, Select, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { bannerSelector } from "../../../services/selector/index.";
import {
  IconEdit,
  IconLock,
  IconNext,
  IconPre,
  IconSpin,
  IconXmark,
} from "../../../assets/icon";
import "../../../assets/style/table/product.scss";
import { useState } from "react";
import { useMemo } from "react";
import { setOpenPUDelete } from "../../../services/slice/PopUpSlice";
import TranslateText from "../TranslateText";
import { formatPrice } from "../../../utils/functionCommon";
import { setPageProduct } from "../../../services/slice/StoreSlice";
import { useTranslation } from "react-i18next";
import {
  getBanner,
  getLogBanner,
  setDataSaveAll,
  setLenghtConfig,
  setOpenModalEditBanner,
} from "../../../services/slice/BannerSlice";

const TableAdManager = ({ total = 1, number }) => {
  const dispatch = useDispatch();
  const bannerState = useSelector(bannerSelector);
  const {
    dataBanner,
    refetch,
    listChangeBanner,
    isOpenModalEditBanner,
    numberBannerDefault,
  } = bannerState;
  const [page, setPage] = useState(0);
  const { t } = useTranslation();
  const [dataBackUp, setDataBackUp] = useState([]);
  useEffect(() => {
    if (dataBanner.length) {
      setDataBackUp(dataBanner);
    }
  }, [dataBanner.length]);
  useEffect(() => {
    dispatch(getBanner());
  }, []);
  useEffect(() => {
    dispatch(getBanner(bannerState.config));
  }, [bannerState.config]);
  useEffect(() => {
    if (refetch) {
      dispatch(getBanner());
    }
  }, [refetch, dispatch]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  //select
  const onSelectChange = (newSelectedRowKeys) => {
    if (newSelectedRowKeys.length <= numberBannerDefault) {
      setSelectedRowKeys(newSelectedRowKeys);

      let dataUpdate = [];
      dataUpdate = dataBackUp.map((item) => {
        if (newSelectedRowKeys.includes(item.id)) {
          return {
            ...item,
            status: 1,
          };
        } else {
          return {
            ...item,
            status: 0,
          };
        }
      });
      setDataBackUp(dataUpdate);
      return;
    } else {
      Modal.error({
        className: "wrapperModalErrConfigBanner",
        centered: true,
        width: 590,
        title: <span style={{ fontSize: 20, fontWeight: 700 }}>Lỗi</span>,

        content: (
          <>
            <p style={{ fontSize: 20 }}>
              Cấu hình số lượng banner hiển thị tối đa là{" "}
              <span style={{ color: "#047DE7" }}>{numberBannerDefault}</span>{" "}
            </p>
            <p style={{ fontSize: 20 }}>
              Bạn không thể chọn nhiều hơn số lượng banner tối đa đã được thiết
              lập.Vui lòng thiết lập lại.
            </p>
          </>
        ),
      });
    }
  };
  useEffect(() => {
    dispatch(setLenghtConfig(selectedRowKeys.length));
  }, [selectedRowKeys, dispatch]);

  useEffect(() => {
    let dataUpdateSaveAll = [...listChangeBanner];
    if (dataUpdateSaveAll.length < selectedRowKeys.length) {
      selectedRowKeys.forEach((key) => {
        const indexItem = listChangeBanner.findIndex((item) => item.id === key);
        if (indexItem === -1) {
          const newItem = {
            id: key,
            index: dataBanner.find((item) => item.id === key).index,
            status: 1,
          };
          dataUpdateSaveAll.push(newItem);
        }
      });
    } else {
      dataUpdateSaveAll = dataUpdateSaveAll.filter((item) =>
        selectedRowKeys.includes(item.id)
      );
      dataBackUp.map((item) => {
        if (!selectedRowKeys.includes(item.id))
          return dataUpdateSaveAll.push({
            id: item.id,
            index: item.index,
            status: 0,
          });
        else return item;
      });
    }

    dispatch(setDataSaveAll(dataUpdateSaveAll));
  }, [dispatch, selectedRowKeys]);
  const rowSelection = {
    selectedRowKeys,
    columnTitle: true,
    onChange: onSelectChange,
  };

  const handleChangeNumOrder = (value, banner) => {
    let dataUpdate = [...dataBackUp];
    let dataUpdateSaveAll = [...listChangeBanner];
    dataUpdateSaveAll.map((item) => {
      if (item.id === banner.key) {
        return {
          ...item,
          index: value,
        };
      } else return item;
    });
    dispatch(setDataSaveAll(dataUpdateSaveAll));
    dataUpdate = dataUpdate.map((item) => {
      if (item.id === banner.key) {
        return {
          ...item,
          index: value,
        };
      } else return item;
    });
    setDataBackUp(dataUpdate);
  };
  const dataSource = useMemo(() => {
    const result = [];
    const listBannerPic = [];
    if (dataBackUp) {
      const dataUpdateSaveAll = [];
      dataBackUp.map((banner) => {
        if (banner.status === 1) {
          listBannerPic.push(banner.id);
          dataUpdateSaveAll.push({
            id: banner.id,
            index: banner.index,
            status: banner.status,
          });
        }
        return result.push({
          key: banner.id,
          imageBanner: banner.urlImage,
          name: banner.name,
          link: banner.link,
          timeStart: banner.timeStart,
          timeEnd: banner.timeEnd,
          index: banner.index,
          status: banner.status,
        });
      });
      dispatch(setDataSaveAll(dataUpdateSaveAll));
    }
    setSelectedRowKeys([...listBannerPic]);
    return result;
  }, [dataBackUp, numberBannerDefault]);

  const handleShowModalDelete = (value) => {
    dispatch(
      setOpenPUDelete({ stateOpen: true, content: value.name, id: value.key })
    );
  };
  const handleShowEditModal = (value) => {
    dispatch(setOpenModalEditBanner({ isOpen: true, valueEdit: value }));
  };
  const optionSelect = useMemo(() => {
    let result = [];
    for (let i = 1; i <= number; i++) {
      result.push({
        value: i,
        label: i,
      });
    }
    return result;
  }, [number]);
  const columns = [
    {
      title: <TranslateText text="Ảnh banner" />,
      dataIndex: "imageBanner",
      key: "imageBanner",
      className: "centerCell imgTable",
      render: (url, record) => (
        <Image
          style={{
            display: "block",
            objectFit: "contain",
          }}
          alt={`Image ${record.name}`}
          width={100}
          height={70}
          src={`${window.SERVER_URL_ADS}/${url}`}
        />
      ),
    },
    {
      title: <TranslateText text="Tên banner" />,
      dataIndex: "name",
      key: "name",
      ellipsis: {
        showTitle: false,
      },
      render: (name) => (
        <Tooltip placement="topLeft" title={name}>
          {name}
        </Tooltip>
      ),

      className: "centerCell",
    },
    {
      title: <TranslateText text="Liên kết" />,
      dataIndex: "link",
      key: "link",
      ellipsis: {
        showTitle: false,
      },
      className: "title collapseText centerCell",
      render: (link) => (
        <Tooltip placement="topLeft" title={link}>
          {link}
        </Tooltip>
      ),
    },

    {
      title: <TranslateText text="Thời gian bắt đầu" />,
      dataIndex: "timeStart",
      key: "timeStart",
      className: "centerCell",
    },
    {
      title: <TranslateText text="Thời gian kết thúc" />,
      dataIndex: "timeEnd",
      key: "timeEnd",
      className: "centerCell",
      render: (text) => <span>{formatPrice(text)}</span>,
    },
    {
      title: <TranslateText text="Thứ tự hiển thị" />,
      dataIndex: "indexShow",
      key: "indexShow",
      className: "centerCell",
      render: (text, record) => {
        return (
          <Select
            disabled={!record.status}
            className="base"
            defaultValue={record.index}
            style={{
              width: 55,
            }}
            onChange={(value) => handleChangeNumOrder(value, record)}
            options={optionSelect}
          />
        );
      },
    },
    {
      title: <TranslateText text="Chức năng" />,
      key: "action",
      dataIndex: "action",
      className: "centerCell m10",
      render: (text, record) => {
        return (
          <>
            <div className="centerCell" style={{ minWidth: "120px" }}>
              <span
                className="pointer iconTbl"
                onClick={() => dispatch(getLogBanner(record.key))}
              >
                <Tooltip title="Xem log">
                  <IconLock />
                </Tooltip>
              </span>
              <span
                className="pointer iconTbl"
                onClick={() => handleShowEditModal(record)}
                style={{ marginRight: "1rem" }}
              >
                <Tooltip title="Chỉnh sửa">
                  <IconEdit />
                </Tooltip>
              </span>
              <span
                className="pointer iconTbl"
                onClick={() => handleShowModalDelete(record)}
              >
                <Tooltip title="Xóa">
                  <IconXmark />
                </Tooltip>
              </span>
            </div>
          </>
        );
      },
    },
  ];
  const tableLoading = {
    // spinning: storeState.isLoading,
    indicator: <IconSpin className="iconSpin" />,
  };
  return (
    <>
      <Row style={{ width: "100%" }}>
        <Table
          rowSelection={rowSelection}
          // loading={tableLoading}
          className="wrapperTblProduct"
          style={{ width: "100%", marginTop: "2.6rem" }}
          columns={columns}
          dataSource={dataSource}
          pagination={
            total > 10
              ? {
                  onChange: (value) => {
                    setPage(value);
                    dispatch(setPageProduct(value));
                  },
                  total,
                  pageSize: 10,
                  prevIcon: <IconPre />,
                  nextIcon: <IconNext />,
                  showSizeChanger: false,
                }
              : false
          }
        />
      </Row>
    </>
  );
};

export default TableAdManager;
